import { useEffect, useRef, useState } from "react";
import { Map, Overlay } from "ol";
import { Coordinate } from "ol/coordinate";

// Anchors an element just right of a point of interest. Takes a coordinate
// rather than a feature, since the POI features are rebuilt on every change.
export function usePOIOverlay(map: Map | null, position: Coordinate | undefined) {
	const poiOverlayElRef = useRef<HTMLElement | null>(null);

	const [overlay, setOverlay] = useState<Overlay | null>(null);

	useEffect(() => {
		if (!map) return () => {};

		const overlay = new Overlay({
			element: poiOverlayElRef.current!,
			positioning: "center-left",
			offset: [12, 0],
		});

		map.addOverlay(overlay);
		setOverlay(overlay);

		return () => {
			setOverlay(null);
			map.removeOverlay(overlay);
		};
	}, [map]);

	useEffect(() => {
		overlay?.setPosition(position);
	}, [overlay, position]);

	return { poiOverlayElRef };
}
